import {ClientId, FromServerId, NLOToServerId, ToServerId} from 'notebook/ELNConstants';
import {CidIdMap} from 'notebook/notes/NoteConstants';
import {addCid} from 'notebook/store/StoreTransformUtil';
import {GenericNoteLinkedScratchPlateDesign} from 'notebook/util/NoteUtilConstants';

export type FromServerNoteLinkedScratchPlateDesign = GenericNoteLinkedScratchPlateDesign<FromServerId>;
export type NoteLinkedScratchPlateDesign = GenericNoteLinkedScratchPlateDesign<ClientId>;
export type ToServerNoteLinkedScratchPlateDesign = GenericNoteLinkedScratchPlateDesign<ToServerId>;

/**
 * Transform {@link FromServerNoteLinkedScratchPlateDesign} into a {@link NoteLinkedScratchPlateDesign}
 *
 * Invoked when loading a note into the document store. Replaces the server id with a cid,
 * which is rehydrated on save via {@link prepareForSave}.
 */
export function prepareForStore(item: FromServerNoteLinkedScratchPlateDesign, cidIdMap: CidIdMap): void {
  addCid(item, 'scratch-plate-design-', cidIdMap);
}

/**
 * Transform a {@link NoteLinkedScratchPlateDesign} back into a server-ready representation.
 *
 * Invoked when saving a note. Rehydrates the server id from the cidIdMap.
 */
export function prepareForSave(
  item: NoteLinkedScratchPlateDesign,
  cidIdMap: CidIdMap
): ToServerNoteLinkedScratchPlateDesign {
  return {
    id: cidIdMap[item.cid] as NLOToServerId['id'],
    cid: item.cid,
    type: item.type,
    name: item.name,
    data: item.data,
  };
}
